const regionNames = new Intl.DisplayNames(['en'], { type: 'region' })

export const formatCountryName = (countryCode: string): string => {
  const code = countryCode.toUpperCase()
  try {
    const name = regionNames.of(code)
    if (name) return `${name}, ${code}`
  } catch {
    // Invalid code, fall through
  }
  return code
}
